import { MARQUEE_ITEMS } from "../data/content";

export const Marquee = () => (
  <div
    className="relative overflow-hidden border-y border-[rgba(247,244,239,0.1)] bg-[#1a1613] py-5"
    data-testid="marquee"
    aria-hidden="true"
  >
    <div className="marquee-track">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0 items-center">
          {MARQUEE_ITEMS.map((item) => (
            <span key={`${dup}-${item}`} className="flex items-center">
              <span className="font-display whitespace-nowrap px-7 text-lg italic text-[#b5afa7]">
                {item}
              </span>
              <span className="h-1.5 w-1.5 rounded-full bg-[#d4af37]" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
